<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-press-escape="false"
        title="启用成员"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="成员：" prop="name" class="label-required">
                {{userList.map(item=>item.name).join('，')||'--'}}
            </el-form-item>
            <el-form-item label="角色：" prop="role_ids">
                <ESelect v-model="formItem.role_ids" filterable multiple class="full-w role-select" placeholder="请选择角色">
                    <el-option
                        v-for="item in roleList"
                        :key="item.id"
                        :label="item.role_name"
                        :disabled="item.disabled"
                        :value="item.id">
                    </el-option>
                </ESelect>
            </el-form-item>


        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/department.js';

    export default {
        name: "MemberDepartmentModal",
        components:{},
        props:{
            userList:{
                required:true,
                type:Array,
            },
        },
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                formItem: {
                    role_ids:null,
                },
                rules:{
                    role_ids: [
                        { type: 'array', required: true, message: '请选择成员角色', trigger: 'blur'},
                    ],
                },
                roleList: [],
            }
        },
        computed: {
            isBatch() {
                return Array.isArray(this.userList) && this.userList.length > 1;
            },
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
                this.$emit('close');
            },
            showModal() {
                this.dialogVisible = true;
                this.getRoleList();
                this.$nextTick(()=>{
                    if (!this.isBatch) {


                    }
                })
            },
            getRoleList(){
                API.getRoleList({
                    user_id:this.id,
                }).then(res => {
                    this.roleList = res.data || [];
                }, (err) => {
                    console.log('getUserList error', err);
                    this.roleList = [];
                });
            },
            resetForm() {
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            handleSubmit(){

                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let users = this.userList.map(item=>item.id);
                        API.userRestore({
                            ids:users.join(','),
                            role_ids:this.formItem.role_ids,
                        }).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.dialogVisible = false;
                            this.resetForm();
                            this.$emit('update');
                        }, (err) => {
                            console.log('userRestore error', err);
                            this.$message.error(err.info || '操作失败');
                            this.submitLoading = false;
                        });

                    } else {
                        return false;
                    }
                });
            },
            selectDepartment(node){
                if(node.disable){
                    this.$message.error(`【${node.name}】不可选择`);
                    this.$nextTick(()=>{

                    })
                }
            },
            getLabelClassName(node){
                let rawNode = node.raw||{};
                return rawNode.disable?"option-label-disabled":'';
            },
        }
    }
</script>

<style scoped>
    .action-btn {
        width: 120px;
    }
    .option-label-disabled{
        color: #bbb;
        cursor: not-allowed;
        display: inline-block;
        width: 100%;
    }
</style>
